/* istanbul ignore file */
import React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  Grid,
  Accordion,
  AccordionDetails,
} from '@material-ui/core';
import { toast } from 'react-toastify';
import victimIcon from 'images/victim-icon.svg';
import { COLORS } from 'constants/design';
import {
  formatExpertReport,
  formatImportReport,
} from 'containers/TransactionManagerTimeLine/ContactVictim/utils';
import ExpertRecap from 'containers/TransactionManagerTimeLine/ContactVictim/JudiciaryRecapExpertise';
import AccordionExpandIcon from 'components/SahamIcons/AccordionExpandIcon';
import { StyledTypography } from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/style';
import { IntlShape, injectIntl } from 'react-intl';
import { get, isEmpty } from 'lodash';
import CloseIcon from '@material-ui/icons/Close';
import {
  StyledDialog,
  styledIcon,
  StyledAccordionSummary,
} from 'containers/TransactionManagerTimeLine/ContactVictim/style';
import { translate } from 'containers/services/translate';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import messages from 'containers/TransactionManagerTimeLine/ContactVictim/messages';
import MedicalFormRecap from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/MedicalFormRecap';
import {
  EXPERTISE_ACCOUNTING_ID,
  EXPERTISE_MEDICAL_ID,
} from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import AccountingFormRecap from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/AccountingFormRecap';
import { VictimType, TransactionType } from 'typings/globalTypes';
export interface ImportedReportDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  handleValidate: Function;
  judiciaryExpertisesVictim: any;
  requestImportMissionExpertise: Function;
  transactionId: number;
  sagisVictimInfo: any;
  listings: any;
  claimId: number;
  sagisOpposingParties: any;
  expertJudiciaryExpertise: any;
  victim: VictimType;
  transactionInfo: TransactionType;
  requestGetDocByDocumentumId: Function;
}
const styledTitle = {
  color: '#172C51 !important',
  fontSize: '20px',
  lineHeight: '24.42px',
};

const ImportedReportDialog: React.FC<ImportedReportDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [checked, setChecked] = React.useState('');

  const handleClose = () => {
    onClose(false);
    setChecked('');
  };
  const successCallback = () => {
    toast.success(translate(messages.successImportTitle, props));
    handleClose();
  };

  const handleValidateImportDialog = () => {
    props.requestImportMissionExpertise(
      {
        ...formatImportReport(
          props.judiciaryExpertisesVictim,
          checked,
          props.transactionId,
          formatExpertReport(props.expertJudiciaryExpertise, props.victim),
          props.transactionInfo,
          props.claimId,
        ),
      },
      successCallback,
    );
  };

  const renderRecapByMissionType = (recap: any) => {
    if (Number(recap.mission.type) === EXPERTISE_MEDICAL_ID) {
      return (
        <MedicalFormRecap
          recap={recap}
          handleOpenDialogValidation={() => {}}
          handleOpenDialogRejection={() => {}}
          handleOpenAppreciationDialog={() => {}}
          isLawyer={true}
          isTransaction={false}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      );
    } else if (
      Number(recap.mission.type) === EXPERTISE_ACCOUNTING_ID &&
      get(recap, 'mission.victims')
    ) {
      return (
        <AccountingFormRecap
          recap={recap}
          handleOpenDialogValidation={() => {}}
          handleOpenDialogRejection={() => {}}
          handleOpenAppreciationDialog={() => {}}
          isLawyer={true}
          isTransaction={false}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      );
    } else {
      return <></>;
    }
  };

  return (
    <StyledDialog onClose={handleClose} open={open}>
      <DialogTitle>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-between"
        >
          <Grid item xs={9}>
            <span style={styledTitle}>
              {translate(messages.importMissionDialogTitle, props)}
            </span>
          </Grid>
          <Grid item>
            <CloseIcon onClick={handleClose} />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        {!isEmpty(props.expertJudiciaryExpertise) &&
          formatExpertReport(props.expertJudiciaryExpertise, props.victim).map(
            (document: any, documentIndex: number) => (
              <Accordion elevation={0} style={{ marginBottom: '20px' }}>
                <StyledAccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  expandIcon={<AccordionExpandIcon />}
                  textColor={COLORS.ACCORDION_TEXT_BLUE}
                  bgColor={COLORS.ACCORDION_BG_BLUE}
                >
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    alignItems="center"
                  >
                    <Grid item>
                      <FormControlLabel
                        onChange={(e: any) => {
                          setChecked(get(e.target, 'name'));
                        }}
                        aria-label="rapport"
                        onClick={event => event.stopPropagation()}
                        onFocus={event => event.stopPropagation()}
                        control={
                          <Radio
                            color="primary"
                            name={
                              get(
                                document,
                                'victims.[0].victimExpertise.id',
                              ) as any
                            }
                            checked={
                              checked ===
                              String(
                                get(document, 'victims.[0].victimExpertise.id'),
                              )
                            }
                          />
                        }
                        label=""
                        style={{
                          marginRight: '-11px',
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <img
                        src={victimIcon}
                        className="request-icon"
                        alt="request-icon"
                        style={styledIcon}
                      />
                    </Grid>
                    <Grid item xs>
                      <StyledTypography>
                        {translate(
                          messages.accordionJudiciaryReportTitle,
                          props,
                        )}
                      </StyledTypography>
                    </Grid>
                  </Grid>
                </StyledAccordionSummary>
                <AccordionDetails>
                  <ExpertRecap
                    expertReportState={
                      formatExpertReport(
                        props.expertJudiciaryExpertise,
                        props.victim,
                      ) as any
                    }
                    listings={props.listings}
                    claimId={props.claimId}
                    readOnly={true}
                    expertReport={
                      formatExpertReport(
                        props.expertJudiciaryExpertise,
                        props.victim,
                      ) as any
                    }
                    setExpertReportState={() => {}}
                    documentIndex={documentIndex}
                    expertises={
                      formatExpertReport(
                        props.expertJudiciaryExpertise,
                        props.victim,
                      ) as any
                    }
                    isAssignedLawyer={false}
                    claimNumber={'' as any}
                    sagisVictimInfo={props.sagisVictimInfo}
                    sagisOpposingParties={props.sagisOpposingParties}
                    imagineDocuments={[]}
                    requestGetDocByDocumentumId={
                      props.requestGetDocByDocumentumId
                    }
                  />
                </AccordionDetails>
              </Accordion>
            ),
          )}

        {!isEmpty(props.judiciaryExpertisesVictim) &&
          props.judiciaryExpertisesVictim.map((element: any) => (
            <Accordion elevation={0} style={{ marginBottom: '20px' }}>
              <StyledAccordionSummary
                aria-controls="panel1a-content"
                id="panel1a-header"
                expandIcon={<AccordionExpandIcon />}
                textColor={COLORS.ACCORDION_TEXT_BLUE}
                bgColor={COLORS.ACCORDION_BG_BLUE}
              >
                <Grid container direction="row" spacing={2} alignItems="center">
                  <Grid item>
                    <FormControlLabel
                      onChange={(e: any) => {
                        setChecked(get(e.target, 'name'));
                      }}
                      aria-label="rapport"
                      onClick={event => event.stopPropagation()}
                      onFocus={event => event.stopPropagation()}
                      control={
                        <Radio
                          color="primary"
                          name={element.id}
                          checked={checked === String(element.id)}
                        />
                      }
                      label=""
                      style={{
                        marginRight: '-11px',
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <img
                      src={victimIcon}
                      className="request-icon"
                      alt="request-icon"
                      style={styledIcon}
                    />
                  </Grid>
                  <Grid item xs>
                    <StyledTypography>
                      {translate(messages.accordionTitle, props)}
                    </StyledTypography>
                  </Grid>
                </Grid>
              </StyledAccordionSummary>
              <AccordionDetails>
                {renderRecapByMissionType({
                  ...element,
                  victim: get(element, 'mission.victims[0]'),
                  victimIncome: get(element, 'victimRevenue'),
                })}
              </AccordionDetails>
            </Accordion>
          ))}
      </DialogContent>

      <DialogActions className="success-actions">
        {checked != '' && (
          <>
            <SecondaryButton
              onClick={handleClose}
              disableElevation
              data-testId="cancel-button"
              title={translate(messages.cancel, props)}
            />
            <PrimaryButton
              onClick={handleValidateImportDialog}
              disableElevation
              data-testId="validate-button"
              className="primary-button"
              title={'Importer'}
              disabled={false}
            />
          </>
        )}
      </DialogActions>
    </StyledDialog>
  );
};

export default injectIntl(ImportedReportDialog);
